import axios from 'axios';

const closeMerchentAccountApi = async (values, token, langIsoCode) => {
  try {
    const res = await axios.post('/Auth_private/closeMySaloon', values, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + token,
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default closeMerchentAccountApi;
